var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xl font-medium tracking-wide select-none"},[_vm._v("Module Title")])
}
var staticRenderFns = []

export { render, staticRenderFns }